import React from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';

/**
 * EngagementBadge - Shows engagement percentage with lightning bolts
 * Used in agenda cards to display engagement metrics
 * Shows 1-3 lightning icons based on engagement percentage
 */
const EngagementBadge = ({
  percentage,
  size = 'sm',
  ...props
}) => {
  // Calculate number of lightning bolts based on percentage
  const getLightningCount = (percent) => {
    if (percent >= 67) return 3;
    if (percent >= 34) return 2;
    return 1;
  };

  const lightningCount = getLightningCount(percentage);
  const lightningIcons = '⚡'.repeat(lightningCount);
  const sizes = {
    sm: {
      padding: '6px',
      fontSize: '11px',
      height: 'auto',
      minWidth: '45px',
    },
    md: {
      padding: '8px 12px',
      fontSize: '12px',
      height: '32px',
      minWidth: '60px',
    },
  };

  const sizeProps = sizes[size] || sizes.sm;

  return (
    <Box
      borderRadius="6px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      transition="all 0.2s"
      _hover={{
        bg: '#EDEAF2',
        transform: 'translateY(-1px)',
      }}
      {...sizeProps}
      {...props}
    >
      <HStack spacing="8px" align="center">
        <Text
          fontSize={sizeProps.fontSize}
          fontWeight="400"
          color="#363636"
          lineHeight="1.455"
          letterSpacing="-1%"
          fontFamily="Geist, sans-serif"
          textAlign="center"
        >
          {percentage}%
        </Text>
        <Text
          fontSize={sizeProps.fontSize}
          lineHeight="1.455"
          fontFamily="Geist, sans-serif"
        >
          {lightningIcons}
        </Text>
      </HStack>
    </Box>
  );
};

export default EngagementBadge;
